document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("sofaMitnahmeToggle");
  const message = document.getElementById("toggleMessage");

  // 🛒 Variant-ID für "Mitnahme altes Sofa" (bitte anpassen)
  const mitnahmeVariantId = 52231958528369;

  if (toggle) {
    toggle.addEventListener("change", function () {
      if (toggle.checked) {
        // ✅ Zeige den Info-Text an
        if (message) message.style.display = "block";

        // 🛍 Produkt in den Warenkorb legen (nur wenn nicht schon drin)
        fetch("/cart.js")
          .then(response => response.json())
          .then(cart => {
            const itemExists = cart.items.some(i => i.variant_id === mitnahmeVariantId);
            if (!itemExists) {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: mitnahmeVariantId, quantity: 1 })
              });
            }
          })
          .then(response => response?.json())
          .then(data => console.log("🛒 Produkt hinzugefügt:", data))
          .catch(error => console.error("⚠️ Fehler:", error));
      } else {
        // ❌ Verstecke den Info-Text
        if (message) message.style.display = "none";

        // 🚮 Produkt aus dem Warenkorb entfernen
        fetch("/cart.js")
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(i => i.variant_id === mitnahmeVariantId);
            if (item) {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            }
          })
          .then(response => response?.json())
          .then(data => console.log("🚮 Produkt entfernt:", data))
          .catch(error => console.error("⚠️ Fehler:", error));
      }
    });
  } else {
    console.error("❌ Toggle-Element nicht gefunden!");
  }
});
